import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { tap, map } from 'rxjs/operators';

import { ApiService, HttpMethod } from '../common/api.service';
import { ApiUrlService } from '../common/api-url.service';
import { AuthenticatedUser } from './authenticated-user.model';
import { LocalStorageManagerService } from '../../core/managers/local-storage-manager.service';
import { UserLoginResult } from './user-login-result.model';
import { UserRegistrationInfo } from './user-registration-info.model';
import { UserLoginInfo } from './user-login-info.model';

@Injectable({
    providedIn: 'root'
})
export class AuthApiService extends ApiService
{
    constructor(protected http: HttpClient,
                protected apiUrlService: ApiUrlService,
                private localCacheManager: LocalStorageManagerService)
    {
        super(http);
    }

    signIn(email: string, password: string, tenantId: string, organizationId: number): Observable<AuthenticatedUser>
    {
        const userLoginInfo = new UserLoginInfo(email, password, tenantId, organizationId);
        return this.apiRequest<AuthenticatedUser>(this.apiUrlService.loginUrl, HttpMethod.Post, JSON.stringify(userLoginInfo))
            .pipe(
                tap(response => this.localCacheManager.userLoginResult = new UserLoginResult(response)),
                map(response => new AuthenticatedUser(response))
            );
    }

    signInWithRefreshToken(refreshToken: string, organizationId?: number)
    {
        let httpBody = `{ "grantType": "refresh_token", "refreshToken": "${refreshToken}", "LocationId": 1 }`;
        if (organizationId)
        {
            httpBody = `{ "grantType": "refresh_token", "RefreshToken": "${refreshToken}", "organizationId": ${organizationId} }`;
        }

        return this.apiRequest<AuthenticatedUser>(
            this.apiUrlService.loginUrl, HttpMethod.Post, httpBody)
            .pipe(
                map(response =>
                {
                    return new AuthenticatedUser(response);
                })
            );
    }

    changePassword(oldPassword: string, newPassword: string)
    {
        return this.apiRequest(
            this.apiUrlService.changePasswordUrl, HttpMethod.Post, `{ "oldPassword": "${oldPassword}", "newPassword": "${newPassword}" }`);
    }

    forgotPassword(userName: string)
    {
        return this.apiRequest(this.apiUrlService.forgotPasswordUrl, HttpMethod.Post, `{ "username": "${userName}" }`);
    }

    resetPassword(userId: string, token: string, password: string)
    {
        const httpBody = `{ "userId": "${userId}", "token": "${token}", "password": "${password}" }`;
        return this.apiRequest(this.apiUrlService.resetPasswordUrl, HttpMethod.Post, httpBody);
    }

    registerUser(email: string, password: string)
    {
        const json = {
            email: email,
            password: password,
        };
        return this.apiRequest(this.apiUrlService.registerUserUrl, HttpMethod.Post, JSON.stringify(json));
    }

    confirmEmail(confirmInfo: { userId: string, token: string })
    {
        return this.apiRequest(this.apiUrlService.confirmEmailUrl, HttpMethod.Post, JSON.stringify(confirmInfo));
    }

    // getAvailableUserClaims(): Observable<UserClaim[]>
    // {
    //     return this.apiRequest(this.apiUrlService.availableUserClaimsUrl, HttpMethod.Get)
    //         .map((userClaims: UserClaim[]) =>
    //         {
    //             const claims: UserClaim[] = [];
    //
    //             userClaims.forEach(claim => {
    //                 claims.push(new UserClaim(claim));
    //             });
    //
    //             return claims;
    //         });
    // }

    // setUserClaims(setClaimsModel: SetClaimsModel)
    // {
    //     return this.apiRequest(this.apiUrlService.setuserClaimsUrl, HttpMethod.Put, JSON.stringify(setClaimsModel));
    // }
    //
    // getAvailableUserRoles()
    // {
    //     return this.apiRequest(this.apiUrlService.availableUserRolesUrl, HttpMethod.Get);
    // }

}
